<template>
  <div class="upgrade-rights">
    <div class="left-container">
      <div class="content">
        <div class="title">
          {{ current.title }}
        </div>
        <div v-if="current.subTitle" class="title !text-primary my-[6px]">
          {{ current.subTitle }}
        </div>
        <div class="description">{{ current.description }}</div>
        <div class="flex flex-nowrap gap-x-[20px]">
          <CreateTasteCheck>
            <a-button
              type="primary"
              size="large"
              class="!text-14 font-semibold"
            >
              {{ $t('chuang-jian-tuan-dui') }}
            </a-button>
          </CreateTasteCheck>
          <a-button
            type="dashed"
            size="large"
            class="bg-purple-1 text-primary border-none hover:border-none hover:bg-purple-3 !text-14 font-semibold w-[102px]"
            @click="handleSubscribe"
          >
            {{ $t('le-jie-geng-duo') }}
          </a-button>
        </div>
      </div>
    </div>
    <div class="right-container">
      <div
        class="tab-container"
        :class="{ center: currentList.length <= 2, occupancy: !allowChange }"
      >
        <template v-if="allowChange">
          <div
            v-for="(item, index) of currentList"
            :key="item.id"
            class="tab-item"
            :class="{ active: item.id === current.id }"
            @click="handleChangeTab(index)"
          >
            <span class="icon">
              <iconpark-icon :name="item.type" size="16"></iconpark-icon>
            </span>
            <span class="tab-name">{{ item.subTitle }}</span>
          </div>
        </template>
      </div>
      <div class="slide-wrapper">
        <a-carousel v-bind="options" ref="carouselRef" :arrows="allowChange">
          <div v-for="item of currentList" :key="item.id" class="card-img">
            <vue-photo-zoom-pro
              :url="
                transformImage(
                  !isChinese()
                    ? isDark
                      ? item.en_dark_url
                      : item.en_url || item.url
                    : item.url
                )
              "
              :high-url="
                transformImage(
                  !isChinese()
                    ? isDark
                      ? item.en_dark_url
                      : item.en_url || item.url
                    : item.url
                )
              "
              type="circle"
              :scale="2"
              :width="110"
              releaseselector="true"
            />
          </div>
          <template #prevArrow>
            <div v-if="currentIndex > 0" class="!left-[14px] flex-center">
              <iconpark-icon
                name="arrowright"
                class="arrow rotate-[180deg]"
              ></iconpark-icon>
            </div>
          </template>
          <template #nextArrow>
            <div
              v-if="currentIndex !== currentList.length - 1"
              class="!right-[10px] flex-center"
            >
              <iconpark-icon name="arrowright" class="arrow"></iconpark-icon>
            </div>
          </template>
        </a-carousel>
        <!-- <div class="zoom">
          <iconpark-icon name="zoom"></iconpark-icon>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import vuePhotoZoomPro from 'vue-photo-zoom-pro'
import 'vue-photo-zoom-pro/dist/style/vue-photo-zoom-pro.css'
import { PageKey } from '~/constants/page'
import CreateTasteCheck from '~/features/createTasteCheck/index.vue'
const { $t } = useNuxtApp()
const runtime = useRuntimeConfig()
const currentTheme = useTheme()

const isDark = computed(() => currentTheme?.value === 'dark')
// const currentTheme = useTheme()

const list = {
  team: [
    {
      id: 1,
      title: $t('gong-xiang-kong-jian-duo-ren-xie-zuo-geng-gao-xiao'),
      subTitle: $t('tuan-dui-xie-zuo-chuang-zuo'),
      description: $t(
        'zhi-chi-tuan-dui-nei-duo-cheng-yuan-xie-zuo-chuang-zuo-ti-gong-gao-xiao-de-qi-ye-tuan-dui-shi-pin-chuang-zuo-ping-tai'
      ),
      url: getFeUrl('/youyan-platform/png/1%402x.png'),
      en_url: getFeUrl('/youyan-platform/png/team-space-0715.png'),
      en_dark_url: getFeUrl('/youyan-platform/png/team-space-en-dark.jpg'),
      type: 'team',
    },
    {
      id: 2,
      title: $t('gong-xiang-kong-jian-duo-ren-xie-zuo-geng-gao-xiao'),
      subTitle: $t('zai-xian-zi-yuan-gong-xiang'),
      description: $t(
        'zhi-chi-tuan-dui-nei-zi-yuan-ji-wen-jian-gong-xiang-ti-gong-tuan-dui-chu-cun-kong-jian'
      ),
      url: getFeUrl('/youyan-platform/png/2%402x.png'),
      en_url: getFeUrl('/youyan-platform/png/share_with_me.png'),
      en_dark_url: getFeUrl('/youyan-platform/png/share-with-me-en-dark.jpg'),
      type: 'resource',
    },
  ],
  brand: [
    {
      id: 1,
      title: $t('tong-yi-gui-fan-gong-chuang-shi-pin-zuo-pin'),
      subTitle: $t('qi-ye-pin-pai-gui-fan-she-zhi'),
      description: $t(
        'shang-chuan-pin-pai-logo-qi-ye-xuan-chuan-pian-deng-qi-ye-pin-pai-gui-fan-fang-bian-tuan-dui-cheng-yuan-yong-tong-yi-gui-fan-gong-chuang-shi-pin-zuo-pin'
      ),
      url: getFeUrl('/youyan-platform/png/5%402x.png'),
      en_url: getFeUrl('/youyan-platform/png/brand-1-0715.png'),
      en_dark_url: getFeUrl('/youyan-platform/png/brand-1-en-dark.png'),
      type: 'brand',
    },
    {
      id: 2,
      title: $t('qi-ye-zhuan-shu-zi-yuan'),
      subTitle: $t('ding-zhi-hua-zi-chan'),
      description: $t(
        'ding-zhi-qi-ye-zhuan-shu-3d-chang-jing-he-qi-ye-zhuan-shu-xu-ni-jiao-se-fang-bian-qi-ye-da-zao-zi-shen-xu-ni-ip'
      ),
      url: getFeUrl('/youyan-platform/png/6%402x.png'),
      en_url: getFeUrl('/youyan-platform/png/brand-2.png'),
      en_dark_url: getFeUrl('/youyan-platform/png/brand-2-en-dark.png'),
      type: 'custom',
    },
  ],
}
const currentList = ref(list.team)
const current = ref(currentList.value[0])
const currentIndex = ref(0)
const router = useRouter()
const route = useRoute()
const carouselRef = ref()
const allowChange = ref(true)

const handleChangeTab = (value: number) => {
  current.value = currentList.value[value]
  currentIndex.value = value
  carouselRef.value.goTo(value)
}
const handleAfterChange = (value: number) => {
  current.value = currentList.value[value]
  currentIndex.value = value
}

const handleSubscribe = () => {
  router.push({ name: PageKey.SUBSCRIBE })
}

const options = {
  dots: false,
  arrows: true,
  infinite: false,
  afterChange: handleAfterChange,
}

if (route.path === '/home/team') {
  currentList.value = list.team
  current.value = list.team?.[0]
  allowChange.value = false
} else {
  currentList.value = list.brand
  current.value = list.brand?.[0]
}

watch(
  () => route.query,
  (values: any) => {
    if (values?.share !== undefined) {
      handleChangeTab(Number(values.share) - 1)
    }
  }
)

onMounted(() => {
  if (route.query.share !== undefined) {
    handleChangeTab(Number(route.query.share) - 1)
  }
})
// onBeforeMount(() => {
//   if (route.path === '/home/team') {
//     currentList.value = list.team
//     current.value = list.team?.[0]
//     allowChange.value = false
//   } else {
//     currentList.value = list.brand
//     current.value = list.brand?.[0]
//   }
// })
</script>
<style lang="scss" scoped>
.upgrade-rights {
  @apply w-full h-auto pt-[5vh] pb-[20vh] xl:px-[10%] 2xl:px-[12%] px-[5%] flex flex-nowrap gap-[50px] select-none justify-around transition-all;

  .left-container {
    @apply w-1/2;
    .content {
      @apply pt-[80px];
      .title {
        @apply text-[30px] text-font-1 leading-[42px] font-semibold;
      }

      .description {
        @apply text-16 leading-[24px] text-font-60 mt-[12px] mb-[30px] max-w-[450px];
      }
    }
  }
  .right-container {
    @apply w-auto;
    .tab-container {
      @apply flex flex-nowrap gap-x-[30px];

      &.center {
        @apply justify-center;
      }

      &.occupancy {
        height: 24px;
      }

      .tab-item {
        @apply text-16 text-font-50 cursor-pointer transition-colors;

        .icon {
          @apply mr-[6px] align-middle opacity-50;
        }

        &.active {
          @apply text-font-1 font-semibold;

          .icon {
            @apply opacity-100;
          }
        }
      }
    }

    .slide-wrapper {
      @apply relative w-[568px] h-auto rounded-[12px] mt-[30px];
      border: 1px solid var(--back-5);

      .card-img {
        @apply h-[380px] pt-[50px] pl-[60px] bg-back-2 rounded-[12px];
      }

      .arrow {
        @apply w-[18px] h-[18px];

        &:hover {
          @apply text-primary;
        }
      }

      :deep(.slick-arrow) {
        @apply w-[34px] h-[34px] leading-[38px] text-center rounded-[50%] backdrop-blur-[16px] text-[20px];
        z-index: 1;
        color: #3d3e3e !important;
        background: rgba(255, 255, 255, 0.8) !important;
        box-shadow: 0px 2px 5px 0px rgba(0, 26, 133, 0.25);
        top: calc(50% + 20px);
        display: flex !important;
        transition: all 0.1s ease;
        &::before {
          display: none;
        }

        &:hover {
          backdrop-filter: blur(1.6px);
          box-shadow: 2px 0 16px #001a851a;
          transform: translateY(-3px) scale(1.08);
        }
      }

      // &:hover {
      //   :deep(.slick-arrow) {
      //     display: flex !important;
      //     background: rgba(255, 255, 255, 1) !important;
      //   }
      // }

      :deep(.vue-photo-zoom-pro) {
        @apply w-full h-full;
        background: var(--back-2);
        box-shadow: 0px 2px 20px 0px rgba(81, 80, 96, 0.06);
        border-radius: 12px 0px 12px 0px;
        .img-preview {
          @apply object-cover w-full h-full rounded-[12px];
        }
      }

      .zoom {
        @apply absolute bottom-[10px] left-[10px] w-[28px] h-[28px] bg-back-1 rounded-[50%] flex justify-center items-center cursor-pointer;
        box-shadow: 0px 2px 6px 0px rgba(86, 80, 220, 0.1);
        backdrop-filter: blur(29px);
      }
    }
  }
}
</style>
